module.exports = __webpack_public_path__ + "images/4a3c3b8a804b867b8ab83a1af79a3ccb6e77af1bd35908e53643f5c427294aec.svg";